<template>
    <div id="home">
        <picture>
            <source :srcset="$url + 'img/bg_inicio.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_inicio.jpg'" type="image/jpeg"> 
            <img id="bg" :src="$url + 'img/bg_inicio.webp'" alt="Background">
        </picture>
        <picture>
            <source :srcset="$url + 'img/logo_inicio.webp'" type="image/webp">
            <source :srcset="$url + 'img/logo_inicio.png'" type="image/jpeg"> 
            <img id="logo-inicio" :src="$url + 'img/logo_inicio.webp'" alt="Background">
        </picture>
        <transition name="fade">
            <router-link v-if="show" class="btn-00" :to="{ name:'entrar' }">Iniciar</router-link>
        </transition>
    </div>
</template>
<script>
export default {
        name: "AvatarComponent",
        data() {
            return {
                show: false
            }
        },
        methods: {
            startGame() {
                this.$router.push('/entrar');
            }
        },
        mounted() {
            this.show = true;
        }
    }
</script>
<style scoped>
    #home {
        width: 100%;
    }
    #bg
    {
        bottom: 0;
        height: 1080px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
    }
    #logo-inicio
    {
        height: 267px;
        left: calc(50% - 315px);
        position: absolute;
        top: calc(50% - 220px);
        width: 630px;
    }
    .btn-00 {
        height: 83px;
        left: calc(50% - 100px);
        position: absolute;
        top: calc(50% - 20px);
        width: 200px;
    }
    .fade-enter-active, .fade-leave-active {
        bottom: 20px;
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        bottom: 0;
        opacity: 0;
    }

    @media screen and (max-width: 550px)
    {
        #bg
        {
            bottom: 0;
            height: auto;
            left: -400px;
            position: fixed;
            width: 1150px;
        }
    }
    @media screen and (max-width: 630px)
    {
        #logo-inicio
        {
            height: auto;
            left: 0;
            width: 100%;
        }
    }
    @media screen and (max-height: 500px)
    {
        #logo-inicio
        {
            left: calc(50% - 200px);
            height: auto;
            top: 20px;
            width: 400px;
        }
        .btn-00 {
            top: calc(100% - 100px);
        }
    }
</style>